import { memo, useContext } from 'react';
import { Handle } from '@xyflow/react';
import classnames from 'classnames';
import { AutomationBuilderCanvasContext } from '../AutomationBuilderCanvasContext';

const AutomationCanvasHandle = memo(({ className, type, position, id, boxId, isIncomplete }) => {
    const { state } = useContext(AutomationBuilderCanvasContext);
    return (
        <Handle
            className={classnames(className, {
                'fm-automation-builder__handler--selected': boxId === state.selected?.name,
                'fm-automation-builder__handler--incomplete': isIncomplete,
            })}
            type={type}
            position={position}
            id={id}
            isConnectable={false}
        />
    );
});

export default AutomationCanvasHandle;
